<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title | translate"
    [isForm]="true"
    (onBack)="onClose()"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <div class="app-page-content">
    <!-- content -->
    <div class="app-page-content">
      <div class="row tw-justify-center">
        <!--deviceId-->
        <div class="md:tw-w-1/2 tw-px-1">
          <list-group-item
            [label]="fields + 'deviceId' | translate"
            [value]="model?.deviceId"
          >
          </list-group-item>
        </div>

        <!-- webhookUrl -->
        <div class="md:tw-w-1/2 tw-px-1">
          <list-group-item
            [label]="fields + 'webhookUrl' | translate"
            [value]="model.webhookUrl"
          >
          </list-group-item>
        </div>
      </div>

      <div *ngFor="let item of model.details" class="row">
        <!--PrivateNumberNumber -->
        <div class="md:tw-w-1/2 tw-px-1">
          <list-group-item
            [label]="'common.senderNumberId' | translate"
            [value]="item?.privateNumberNumber"
          >
          </list-group-item>
        </div>

        <!--DynamicTemplateName-->
        <div class="md:tw-w-1/2 tw-px-1">
          <list-group-item
            [label]="'common.dynamicTemplate' | translate"
            [value]="item?.dynamicTemplateName"
          >
          </list-group-item>
        </div>

        <!--smsText-->
        <div class="md:tw-w-1/2 tw-px-1">
          <list-group-item
            [label]="'common.smsBody' | translate"
            [value]="item?.smsText"
          >
          </list-group-item>
        </div>

        <!--delayValue-->
        <div class="md:tw-w-1/2 tw-px-1">
          <list-group-item
            [label]="fields + 'delayValue' | translate"
            [value]="item?.delayValue"
          >
          </list-group-item>
        </div>

        <!--delayType-->
        <div class="md:tw-w-1/2 tw-px-1">
          <list-group-item
            [label]="fields + 'delayType' | translate"
            [value]="item?.delayType | enumToText : DelayTypeEnumValues"
          >
          </list-group-item>
        </div>

        <!--isActive-->
        <div class="md:tw-w-1/2 tw-px-1">
          <list-group-item
            [label]="'common.isActive' | translate"
            [isShowValue]="false"
          >
            <div
              class="badge badge-light border tw-text-gray-800 tw-text-[13px] text-wrap"
              content
            >
              <i
                [ngClass]="
                  item?.isActive
                    ? 'fas fa-check text-success'
                    : 'fas fa-times text-danger'
                "
              >
              </i>
            </div>
          </list-group-item>
        </div>
      </div>

      <!--phonebooks-->
      <div class="md:tw-w-1/2 tw-px-1" *ngIf="phoneBookFilterList.length > 0">
        <div
          class="tw-w-full tw-my-2 tw-bg-white dark:tw-bg-dark-400 tw-rounded-md"
        >
          <div
            class="border border-secondary rounded tw-flex tw-justify-start flex-column"
          >
            <div
              class="tw-flex tw-justify-start tw-items-center dark:tw-bg-dark-300 tw-bg-gray-300 tw-w-full border-bottom border-secondary tw-px-3 tw-py-4"
            >
              <span
                class="tw-text-gray-800 dark:tw-text-gray-100 tw-font-medium"
                >{{ "common.phonebooks" | translate }}
              </span>
            </div>
            <div class="scroll-div tw-p-3 tw-px-5">
              <div class="row">
                <!-- phonebookItem -->
                <div
                  class="md:tw-w-1/6 tw-my-1 tw-rounded-md"
                  *ngFor="let item of phoneBookFilterList"
                >
                  <div
                    class="list-group-item tw-border tw-border-gray-100 dark:tw-border-dark-100 dark:tw-bg-dark-300 tw-rounded-md tw-flex tw-justify-between tw-items-center tw-h-[50px] tw-w-[125px] bg-light rounded"
                  >
                    <span
                      class="tw-text-gray-800 dark:tw-text-gray-300 dark:tw-border-dark-100 tw-font-medium"
                    >
                      {{ item.name }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-page-body>
